import Link from "next/link"

export default function Footer() {
  return (
    <footer className="flex max-md:flex-col gap-6 py-[81px] max-md:py-10 px-8 max-2xl:px-6 max-md:px-8 border-t border-t-[#5F5F5F] justify-between max-md:justify-center">
      <div className="flex flex-col gap-1 md:w-[335px] w-full">
        <Link href="/">
          <img src="/logoOnliveTV.png" width={102} height={56} />
        </Link>
        <div className="flex max-[1760px]:flex-col max-md:flex-row gap-2 items-center max-[1760px]:items-start text-base font-medium text-white">
          <span className="text-[#AFAFAF] text-sm leading-[18px] font-normal">Một sản phẩm thuộc hệ sinh thái</span>
          <img src="/icons/iconVTVCab.svg" />
        </div>
        <div className="flex flex-col text-[#AFAFAF] text-sm font-normal gap-0.5">
          Theo dõi chúng tôi tại
          <div className="flex gap-4">
            <img src="/icons/iconFacebookSmallNoColor.svg" />
            <img src="/icons/iconYoutubeSmallNoColor.svg" />
          </div>
        </div>
      </div>

      <div className="flex flex-col gap-2 md:w-[335px] w-full">
        <span className="text-base font-medium text-white">Chịu Trách nhiệm nội dung</span>
        <div className="flex flex-col text-[#AFAFAF] text-sm font-normal">
          <span>Ông Trần Hoàng Minh</span>
        </div>
      </div>

      <div className="flex flex-col gap-2 md:w-[335px] w-full">
        <span className="text-base font-medium text-white">Thông tin dịch vụ</span>
        <div className="flex flex-col gap-1 text-[#AFAFAF] text-sm font-normal">
          <span>Giấy phép: Số 337/GP-BTTTT do Bộ Thông tin và Truyền thông cấp ngày 18/11/2024</span>
          <span>Hotline: 1900.866.666</span>
          <span className="flex gap-1">
            Email:
            <Link href="mailto:hotro@onlive.vn" className="underline">
              hotro@onlive.vn
            </Link>
          </span>
        </div>
      </div>

      <div className="flex flex-col gap-2 md:w-[335px] w-full max-sm:h-[110px]">
        <span className="text-base font-medium text-white">Trợ giúp</span>
        <ul className="flex flex-col gap-1 text-[#AFAFAF] text-sm font-normal">
          <Link href={"/dieu-khoan-giao-dich"} target="_blank">
            Chính sách bảo mật
          </Link>
          <Link href={"/dieu-khoan-su-dung"} target="_blank">
            Điều khoản dịch vụ
          </Link>
        </ul>
      </div>
    </footer>
  )
}
